"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Build5OtrAddress = exports.otr = void 0;
const otr_1 = require("./otr");
const otr = (otrAddress = Build5OtrAddress.SHIMMER) => new otr_1.OtrWrapper(otrAddress);
exports.otr = otr;
/**
 * Build.5 OTR Addresses per chain.
 */
var Build5OtrAddress;
(function (Build5OtrAddress) {
    Build5OtrAddress["IOTA"] = "iota1qpwxxaw6fw8zeezefyqf0y7hnrpkcmfa4afc67ywfkpp3gwj0ttzcexhvan";
    Build5OtrAddress["SHIMMER"] = "smr1qp0248uakdvfrhyr58yk5lswhnt033vrhst2j4c77laepdv2rk0psgh4t4x";
    Build5OtrAddress["TEST"] = "rms1qp29ma9mugkrlaq9e60pmdray4sn2zjpet4vyk86cezm0jqpdwuhv68j3vh";
})(Build5OtrAddress || (exports.Build5OtrAddress = Build5OtrAddress = {}));
